// Generated from SVG to Code Figma Plugin

export const ProductLineAudio = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 1.99951V21.9995" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    <path d="M17 6V18" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    <path d="M2 9V15" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    <path d="M22 9V15" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    <path d="M7 6V18" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
  </svg>
);
